export default {"src":"/_next/static/media/iron-bank.62224910.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};